import FlipMove from 'react-flip-move'

import { useBaseTable } from './base-table.model'
import type { TBaseTableProps } from './base-table.types'
import { BaseTableView } from './base-table.view'
import './base-table.styles.scss'

// FIXME: This component is not being used anywhere, we should remove it or replace the existing tables with this one if it's more generic and reusable.
// eslint-disable-next-line import-x/no-unused-modules
export const BaseTable = ({
  headers,
  className,
  colors,
  currentActive,
  customSort,
  data,
  defaultSort,
  isCustomAsc,
  isLoading,
  loadingComponent,
  onClick,
  onTrack,
  rowLimit,
}: TBaseTableProps) => {
  const { colorsMap, rowList, handleSort, isItemAsc, getIsCurrentSelected } = useBaseTable({
    colors,
    data,
    rowLimit,
    customSort,
    isCustomAsc,
    currentActive,
    defaultSort,
  })
  return (
    <BaseTableView className={className}>
      <BaseTableView.TableHeaders>
        {headers.map(item => {
          return (
            <BaseTableView.TableHeaderItem
              handleSort={handleSort}
              isCurrentSelected={getIsCurrentSelected(item.key)}
              isItemAsc={isItemAsc}
              item={item}
              customSort={customSort}
              key={item.key || item.label}
              onTrack={onTrack}
            />
          )
        })}
      </BaseTableView.TableHeaders>
      <BaseTableView.TableBody isLoading={isLoading} loadingComponent={loadingComponent}>
        {rowList.map((item, index) => {
          const color = colorsMap.get(item.id) || colors?.[index]
          return (
            <BaseTableView.TableRow
              color={color}
              headers={headers}
              index={index}
              item={item}
              colors={colors}
              key={`row-${item?.id}`}
              onClick={onClick}
            />
          )
        })}
      </BaseTableView.TableBody>
    </BaseTableView>
  )
}

export const TableWithRowAnimation = ({
  headers,
  className,
  colors,
  currentActive,
  customSort,
  data,
  defaultSort,
  isCustomAsc,
  isLoading,
  loadingComponent,
  onClick,
  onTrack,
  rowLimit,
}: TBaseTableProps) => {
  const { colorsMap, rowList, handleSort, isItemAsc, getIsCurrentSelected } = useBaseTable({
    colors,
    data,
    rowLimit,
    customSort,
    isCustomAsc,
    currentActive,
    defaultSort,
  })
  return (
    <BaseTableView className={className}>
      <BaseTableView.TableHeaders>
        {headers.map(item => {
          return (
            <BaseTableView.TableHeaderItem
              handleSort={handleSort}
              isCurrentSelected={getIsCurrentSelected(item.key)}
              isItemAsc={isItemAsc}
              item={item}
              customSort={customSort}
              key={item.key || item.label}
              onTrack={onTrack}
            />
          )
        })}
      </BaseTableView.TableHeaders>
      <BaseTableView.TableBody isLoading={isLoading} loadingComponent={loadingComponent}>
        <FlipMove enterAnimation="none" leaveAnimation="none">
          {rowList.map((item, index) => {
            const color = colorsMap.get(item.id) || colors?.[index]
            return (
              <BaseTableView.TableRow
                color={color}
                headers={headers}
                index={index}
                item={item}
                colors={colors}
                key={`row-${item?.id}`}
                onClick={onClick}
              />
            )
          })}
        </FlipMove>
      </BaseTableView.TableBody>
    </BaseTableView>
  )
}
